module.exports = new __parcel__URL__("machine_train_button.84e7cf04.png").toString();